import { toggleTheme } from '@/redux/theme/slice';

import { useAppSelector } from './redux';

const useThemeMode = () => {
  const { mode } = useAppSelector(store => store.theme);
  const isDark = mode === 'dark';

  return { mode, toggleTheme, isDark };
};

export default useThemeMode;
